import {SessionLocationFormFieldType} from "../../../../../../components/offering-form/session-bundle/session/location/types";
import {SubSettingsFormFieldsType} from "../../../../../../components/offering-form/general/settings/sub-settings/types";
import {SessionGenInfoFormFields} from "../../../../../../components/offering-form/session-bundle/session/gen-info/types";
import {SessionPricingFormFieldsType} from "../../../../../../components/offering-form/session-bundle/session/pricing/types";
import {baseScalarPricingValidationSchemaFields} from "../../../../../../components/offering-form/general/pricing/validation-schema";
import {SessionAvailabilityFormFieldType} from "../../../../../../components/offering-form/session-bundle/session/availability/types";
import yup from "../../../../../../utils/yup-extended";

export const hasOptions = ["radioButton", "checkBox", "dropDown"];

export const createSessionBasicFormStepFormValidationSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
  description: yup.string().trim().required("Description is required"),
  // coverImage: yup.string().trim().nullable(),
  slug: yup.string().trim().required("Link is required"),
  callDuration: yup.string().trim().required("Duration is required"),
  customCallDuration: yup
    .number()
    .transform((parsedValue, originalValue) =>
      originalValue === "" ? null : parsedValue
    )
    .when("callDuration", (callDuration: any) => {
      if (callDuration === "-1") {
        return yup
          .number()
          .transform((parsedValue, originalValue) =>
            originalValue === "" ? null : parsedValue
          )
          .typeError("Must be a number")
          .min(15, "Must be 15 minutes and above")
          .max(120, "Must be less than 120 minutes")
          .required("Custom duration is required");
      }
      return yup
        .number()
        .transform((parsedValue, originalValue) =>
          originalValue === "" ? null : parsedValue
        )
        .typeError("Must be a number")
        .min(61, "Must be more than 60 minutes")
        .max(120, "Must be less than 120 minutes");
    })
    .min(15, "Must be more than 15 minutes")
    .max(120, "Must be less than 120 minutes")
    .required("Duration is required")
    .typeError("Must be a number"),
  ...baseScalarPricingValidationSchemaFields,
  callLocation: yup.string().trim().required("Location is required"),
  availabilityScheduleId: yup.string().trim().required("Please select a schedule"),
  hideFromProfile: yup.bool().default(false),
  requestCustomerPhoneNumber: yup.bool().default(false),
  isUrlRedirect: yup.bool().default(false),
  redirectAfterPurchase: yup
    .mixed<"none" | "telegram" | "custom-url">()
    .oneOf(["none", "telegram", "custom-url"])
    .default("none"),
  telegramGroupId: yup.string().when("redirectAfterPurchase", {
    is: "telegram",
    then: (schema) =>
      schema
        .required("Telegram group is required")
        .test(
          "telegram-group",
          "Telegram group is required",
          (value) => value !== "none"
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  url_redirect: yup
    .string()
    .nullable()
    .when("isUrlRedirect", {
      is: (isUrlRedirect: boolean) => isUrlRedirect,
      then: (schema) => schema.trim().urlWithEmoji().required("Redirect URL is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export type CreateSessionBasicFormStepFormValuesYup = yup.InferType<
  typeof createSessionBasicFormStepFormValidationSchema
>;

export type CreateSessionBasicFormStepFormValues = SessionGenInfoFormFields &
  SessionLocationFormFieldType &
  SubSettingsFormFieldsType &
  SessionPricingFormFieldsType &
  SessionAvailabilityFormFieldType;
